/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";

import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { ecosystemSlug } from "Config/Config";

//import membership options from json
import EventMembershipStatusOption from "data/Prod/MembershipStatus.json";

const AddNewMemberModal = ({
  roleList,
  afterCloseModalHandler,
  title,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const { t } = useTranslation();
  const params = useParams();

  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [userInput, setUserInput] = useState("");
  const [userOptions, setuserOptions] = useState([]);
  const [userValue, setUserValue] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [roleValue, setRoleValue] = useState(null);
  const [roleData, setRoleData] = useState(null);
  const [memberShipStatusValue, setMemberShipStatusValue] = useState(null);
  const [memberShipData, setmemberShipData] = useState(null);

  const [isAdding, setIsAdding] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [errors, setErrors] = useState({});

  //** Function for Validation */
  const validateForm = () => {
    const newErrors = {};
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    // Case 1: User must be selected.
    if (!userValue || userEmail === "") {
      newErrors.user = t("Please select or invite a user by name or email.");
    }

    // Case 2: User email field must not be empty.
    // Run further checks only if an email is provided
    if (userEmail !== "" && !userEmail.match(mailformat)) {
      newErrors.userEmailIsNotValid = t("Invalid email format") + " !";
    }

    // Case 4: User cannot add themselves.
    if (userInfo.email === userEmail) {
      newErrors.userEmailExists =
        t("You cannot add yourself as a member.") + " !";
    }

    // Role validation
    if (!roleValue) {
      newErrors.role = t("Please assign a role to this member.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get user details
  const getUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?token=${token}` +
        `&userstringinput=${userInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setuserOptions(response.data);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get user input
  const userInputHandler = (val) => {
    setUserInput(val);
    setErrorMessage("");
  };

  //function user Selection
  const userSelectionHandler = (val) => {
    setErrorMessage("");
    if (val) {
      setUserValue(val);
      val._id ? setUserId(val._id) : setUserId(null); // if new user or other than contact user email is added
      val.email ? setUserEmail(val.email) : setUserEmail(val.value); // if new user or other than contact, set value as email
    } else {
      setUserValue(null);
      setUserId(null);
      setUserEmail("");
      setuserOptions([]);
    }

    // Clear all user-related errors on change
    if (errors.user || errors.userEmailExists || errors.userEmailIsNotValid) {
      setErrors((prev) => ({
        ...prev,
        user: "",
        userEmailExists: "",
        userEmailIsNotValid: "",
      }));
    }
  };

  //function for select role
  const roleSelectionHandler = (val) => {
    if (val) {
      setRoleValue(val);
      setRoleData(val.value);
      setErrorMessage("");
    } else {
      setRoleValue(null);
      setRoleData(null);
    }

    if (errors.role) {
      setErrors((prev) => ({ ...prev, role: "" }));
    }
  };

  //function for select memebership status
  const memberShipStatusSelectionHandler = (val) => {
    setMemberShipStatusValue(val);
    setmemberShipData(val.value);
    setErrorMessage("");
  };

  //function for reset user select
  const resetUserSelect = () => {
    setUserValue(null);
    setuserOptions([]);
  };

  //** Function for add/invite event member
  const addProjectMemberHandler = async () => {
    if (!validateForm()) {
      setMessageType("error");
      setAlertMessage("Please fill up the required fields");
      setErrorMessage(t("Please fill up the required fields"));
      return;
    }

    const todayValue = new Date().toISOString().split("T")[0];
    setIsAdding(true);
    try {
      let projectMemberData = {
        user: userId,
        project: params.id ? params?.id : null,
        role: roleData,
        useremail: userEmail,
        moderatorstatus: "1",
        memberstatus: "0",
        projectdetailsurl: window.location.href,
        title,
        requestdate: todayValue,
        joiningdate: "",
      };

      console.log("MemberData---->", projectMemberData);

      let requestUrl =
        url.API_BASE_URL +
        url.API_ADD_PROJECT_MEMBER +
        `?token=${token}&ecosystemslug=${ecosystemSlug}`;

      const response = await postData(requestUrl, projectMemberData);

      setIsAdding(false);
      // console.log(response);

      if (response.status) {
        setMessageType("success");
        resetHandler();

        //hide member modal
        let bootstrapModal = document.querySelector("#addProjectMember");
        let modal = bootstrap.Modal.getInstance(bootstrapModal);
        modal.hide();

        //call member list api function
        afterCloseModalHandler();
      } else {
        setMessageType("error");
        setErrorMessage(response.message);
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.log(error.message);
    }

    setShowAlert(true);
  };

  //** Function for reset
  const resetHandler = () => {
    resetUserSelect();
    // resetRoleSelect();
    // resetMemberStatusSelect();
    roleList.map((roleData) => {
      if (roleData.label == "Member") {
        roleSelectionHandler(roleData);
      }
    });

    EventMembershipStatusOption.map((statusData) => {
      if (statusData.value == "0") {
        memberShipStatusSelectionHandler(statusData);
      }
    });
    setUserInput("");
    setUserId(null);
    setUserEmail("");
    setErrorMessage("");
    setErrors({});
  };

  useEffect(() => {
    roleList.map((roleData) => {
      if (roleData.label == "Member") {
        roleSelectionHandler(roleData);
      }
    });

    EventMembershipStatusOption.map((statusData) => {
      if (statusData.value == "0") {
        memberShipStatusSelectionHandler(statusData);
      }
    });
  }, [roleList]);

  useEffect(() => {
    if (userInput.length > 2) {
      getUserList();
    }
  }, [userInput]);

  const optionsToShow = userOptions.length > 0 ? userOptions : [];

  // Custom styles for CreatableSelect (User) to show red border on error
  const userSelectCustomStyles = {
    control: (base) => ({
      ...base,
      borderColor:
        errors.user ||
        errors.userEmail ||
        errors.userEmailIsNotValid ||
        errors.userEmailExists
          ? "#dc3545"
          : "#ced4da",
      "&:hover": {
        borderColor:
          errors.user ||
          errors.userEmail ||
          errors.userEmailIsNotValid ||
          errors.userEmailExists
            ? "#dc3545"
            : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  // Custom styles for Select (Role) to show red border on error
  const roleSelectCustomStyles = {
    control: (base) => ({
      ...base,
      borderColor: errors.role ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.role ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  return (
    <div
      className="modal fade"
      id="addProjectMember"
      tabIndex="-1"
      aria-labelledby="addProjectMember"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  person_add
                </span>
              </div>
              <div>
                <h3
                  className="offcanvas-title fw-bold text-white mb-0"
                  id="offcanvasLabelDetailsLabel"
                >
                  {t("Invite / Add Member")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Add new members to your project")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="fields-container flex-fill">
                  {/* ----- user select section start ----- */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="memberName"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Invite app users / guest (search by name, email)")}
                    </label>

                    <CreatableSelect
                      isClearable
                      styles={userSelectCustomStyles}
                      className="w-100"
                      placeholder={t("Search by name or email to invite")}
                      options={optionsToShow}
                      value={userValue}
                      onChange={userSelectionHandler}
                      onInputChange={userInputHandler}
                    />

                    {errors.user && (
                      <div className="invalid-feedback d-block">
                        {errors.user}
                      </div>
                    )}
                    {errors.userEmailIsNotValid && (
                      <div className="invalid-feedback d-block">
                        {errors.userEmailIsNotValid}
                      </div>
                    )}
                    {errors.userEmailExists && (
                      <div className="invalid-feedback d-block">
                        {errors.userEmailExists}
                      </div>
                    )}
                  </div>
                  {/* ----- user select section end ----- */}

                  {/* ----- role select section start ----- */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="role"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Role")}
                    </label>

                    <Select
                      isClearable
                      styles={roleSelectCustomStyles}
                      className="w-100"
                      placeholder={t("Assign a role to the member")}
                      options={roleList}
                      value={roleValue}
                      onChange={roleSelectionHandler}
                    />
                    {errors.role && (
                      <div className="invalid-feedback d-block">
                        {errors.role}
                      </div>
                    )}
                  </div>
                  {/* ----- role select section end ----- */}
                </div>

                {/* <!-- ========== Start button and error message Section ========== --> */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                  {/* <!-- ========== Start save button Section ========== --> */}
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={addProjectMemberHandler}
                    disabled={isAdding ? true : false}
                    style={{
                      cursor: isAdding ? "not-allowed" : "pointer",
                    }}
                  >
                    {isAdding ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("Sending...")}
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined me-1">
                          send
                        </span>{" "}
                        {t("Send Invite")}
                      </>
                    )}
                  </button>
                  {/* <!-- ========== End save button Section ========== --> */}
                </div>
                {/* <!-- ========== End button and error message Section ========== --> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewMemberModal;
